var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgArrowDiagLeftUp = function SvgArrowDiagLeftUp(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    className: "arrow-diag-left-up_svg__svg-icon",
    viewBox: "0 0 64 64"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M6.075 20.746v14.67h6.039V16.353l20.343 20.344L52.801 57.04l2.12-2.12 2.12-2.12-20.344-20.343-20.344-20.343h19.063V6.075H6.075z",
    clipRule: "evenodd"
  })));
};
export { SvgArrowDiagLeftUp as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB2aWV3Qm94PSIwIDAgNjQgNjQiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgY2xhc3M9InN2Zy1pY29uIj48cGF0aCBmaWxsLXJ1bGU9ImV2ZW5vZGQiIGNsaXAtcnVsZT0iZXZlbm9kZCIgZD0iTTYuMDc0OTUgMjAuNzQ1NVYzNS40MTZIOS4wOTQ0NUgxMi4xMTRWMjUuODg0OFYxNi4zNTM1TDMyLjQ1NzQgMzYuNjk2OUw1Mi44MDA5IDU3LjA0MDNMNTQuOTIwNiA1NC45MjA2TDU3LjA0MDMgNTIuODAwOUwzNi42OTY5IDMyLjQ1NzRMMTYuMzUzNSAxMi4xMTRIMjUuODg0OEgzNS40MTZWOS4wOTQ0NVY2LjA3NDk1SDIwLjc0NTVINi4wNzQ5NVYyMC43NDU1WiIgZmlsbD0iY3VycmVudENvbG9yIi8+PC9zdmc+";